import { useCallback, useState } from 'react';
import { useOverlayGeojsonMutation } from '../../../../queries/useOverlayGeojsonMutation';
import useLegendStore from '../../../../store/legendStore';
import { useMarkerStore } from '../../../../store/markerStore';
import { IMarker } from '../../../../types/marker';
import { IPolygonLayer } from '../../Map/Layer/DatasetZoneLayer';

export const useLayerControls = (
  onMeshControl: (value: string) => any,
  point: IMarker | null,
  isHavePoint: boolean,
  isHave2DSpectra: boolean
) => {
  const [showLayerSection, setShowLayerSection] = useState(true);
  const [showModelDomainsSection, setShowModelDomainsSection] = useState(true);

  const updateMarker = useMarkerStore((state) => state.updateMarker);

  // ---- datasets visibility:
  const showWavesZones = useLegendStore((state) => state.showWavesZones);

  const setShowWavesZones = useLegendStore((state) => state.setShowWavesZones);

  const showAtmosphereZones = useLegendStore(
    (state) => state.showAtmosphereZones
  );

  const setShowAtmosphereZones = useLegendStore(
    (state) => state.setShowAtmosphereZones
  );

  const showOceanZones = useLegendStore((state) => state.showOceanZones);

  const setShowOceanZones = useLegendStore((state) => state.setShowOceanZones);

  const showOcean3dZones = useLegendStore((state) => state.showOcean3dZones);

  const setShowOcean3dZones = useLegendStore(
    (state) => state.setShowOcean3dZones
  );

  //------------------------

  const showGlobalShapeFile = useLegendStore(
    (state) => state.showGlobalShapeFile
  );
  const setShowGlobalShapeFile = useLegendStore(
    (state) => state.setShowGlobalShapeFile
  );
  const showMesh = useLegendStore((state) => state.showMesh);
  const setShowMesh = useLegendStore((state) => state.setShowMesh);
  const getOverlayGeojson = useOverlayGeojsonMutation();

  const updateMeshSwitch = (state: boolean) => {
    if (point) {
      setShowMesh(state);
      if (state) onMeshControl(point.dataset);
      else onMeshControl('');
    }
  };

  const updateShowShape = useCallback(
    async (
      state: boolean,
      id: string,
      level1: string,
      level2: string,
      color: string
    ) => {
      if (!point || !point.id) return;

      const shape = point.shapeFiles.find(
        (x) => x.Level1 === level1 && x.Level2 === level2
      );

      if (!shape) return;

      shape.IsDisplay = state;

      const updatedShapeFiles = [...point.shapeFiles].map((file) => {
        if (file.Level1 === level1 && file.Level2 === level2) {
          return shape;
        }
        return file;
      });

      updateMarker(point.id, { shapeFiles: updatedShapeFiles });

      if (state && shape?.data === undefined) {
        getOverlayGeojson.mutate(
          { id, level1, level2, color },
          {
            onSuccess: (result: IPolygonLayer[]) => {
              if (!point || !point.id) return;

              const currentShape = point.shapeFiles.find(
                (x) => x.Level1 === level1 && x.Level2 === level2
              );

              if (!currentShape) return;

              const updatedShape = {
                ...currentShape,
                data: result,
              };

              const updatedShapeFilesWithData = [...point.shapeFiles].map(
                (file) => {
                  if (file.Level1 === level1 && file.Level2 === level2) {
                    return updatedShape;
                  }
                  return file;
                }
              );

              updateMarker(point.id, { shapeFiles: updatedShapeFilesWithData });
            },
          }
        );
      }
    },
    [point, updateMarker, getOverlayGeojson]
  );

  return {
    showLayerSection,
    showGlobalShapeFile,
    setShowGlobalShapeFile,
    showMesh,
    isHavePoint,
    isHave2DSpectra,
    point,
    setShowLayerSection,
    updateMeshSwitch,
    updateShowShape,
    showModelDomainsSection,
    setShowModelDomainsSection,
    showAtmosphereZones,
    setShowAtmosphereZones,
    showOcean3dZones,
    setShowOcean3dZones,
    showWavesZones,
    setShowWavesZones,
    setShowOceanZones,
    showOceanZones,
  };
};
